jQuery(document).ready(function () {
//initialize api.
    var base_url = "https://api-fai.analyticom.de";
    var competitionId = 30666459;
    var compFai = 1932095;
    var teamId = 56566;
    var pageSize = 24;
    var teamIdFilter = 10614;
    var api_womens_senior_results = base_url + "/api/live/competition/" + competitionId + "/matches/paginated/past/1/" + teamId + "?page=1&pageSize=" + pageSize + "&teamIdFilter=" + teamIdFilter;
    var api_womens_senior_fixture = base_url + "/api/live/competition/" + competitionId + "/matches/paginated/future/1/" + teamId + "?page=1&pageSize=" + pageSize + "&teamIdFilter=" + teamIdFilter;
    var api_womens_senior_fai_results = base_url + "/api/live/competition/" + compFai + "/matches/paginated/past/1/" + teamId + "?page=1&pageSize=" + pageSize + "&teamIdFilter=" + teamIdFilter;
    var api_womens_senior_fai_fixture = base_url + "/api/live/competition/" + compFai + "/matches/paginated/future/1/" + teamId + "?page=1&pageSize=" + pageSize + "&teamIdFilter=" + teamIdFilter;
    var api_key = "8f03d750e912f7ff66d3b5eb1ca39f66d762785059470f85723d7513a71ae097106e5b8d3a548b85e60d49ec9fec2471e2086e9cc95f2f22f741f1962d3db004";
    var url_faiconnect = "https://faiconnect.ie/file?id=";
//Fixtures section.
    //api_fixtures
    jQuery.ajax({
      url: api_womens_senior_fixture,
      type: "get",
      headers: {
        "API_KEY": api_key,
      },
      dataType: "json",
      success: function (response) {
        var content = "";
        content += "<div id='wrapper-toggle' class='wrapper-toggle'>";
        if (!jQuery.trim(response.result) || jQuery.trim(response.result) == null || jQuery.trim(response.result) == undefined) {
          content += "<div class='empty-val'><p><strong>No results found.</strong></p></div>";
        }
        else {
          jQuery.each(response.result, function (key, value) {
            var home_team_crest = url_faiconnect + value?.homeTeam.picture;
            var away_team_crest = url_faiconnect + value?.awayTeam.picture;
            var competition = value?.competition.name;
            var match_full_date = new Date(value?.dateTimeUTC).toDateString();
            var time_24h = new Date(value?.dateTimeUTC).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
            var venue = value?.facility.name;
            content += "<div class='core-content'>";
            content += "<div class='match-date'><p>" + match_full_date + "</p></div>";
            content += "<div class='match-detail'>";
            content += "<div class='team'><span>" + value?.homeTeam.name + "</span><img id='team-crest' class='team-crest home' src='" + home_team_crest + "' alt='" + value?.homeTeam.place + "' loading='lazy'/></div>";
            content += "<div class='current-result'><span class='match-time'>" + time_24h + "</span></div>";
            content += "<div class='team'><img id='team-crest' class='team-crest away' src='" + away_team_crest + "' alt='" + value?.awayTeam.place + "' loading='lazy'/><span>" + value?.awayTeam.name + "</span></div>";
            content += "</div>";
            content += "<div class='match-date'><p>" + competition + "</p></div>";
            content += "</div>";
            content += "<div class='contents'>";
            content += "<div class='match-extra-info'>";
            content += "<div class='competition'><p>" + competition + "</p></div>";
            content += "<div class='venue'><p>" + venue + "</p></div>";
            //content += "<div class='ticket-btn'><a href='#'>Buy Ticket</a></div>";
            content += "</div>";
            content += "</div>";
          })
        }
        content += "</div>";
        //insert content.
        jQuery('.container-toggle.league.fixture #toggle-block').append(content);
      },
      error: function (errorThrown) {
        console.log(errorThrown);
      },
    });
//Results section.
    jQuery.ajax({
        url: api_womens_senior_results,
        type: "get",
        headers: {
        "API_KEY": api_key,
        },
        dataType: "json",
        success: function (response) {
        //console.log(response);
        var content = "";
        content += "<div id='wrapper-toggle' class='wrapper-toggle'>";
        if (!jQuery.trim(response.result) || jQuery.trim(response.result) == null || jQuery.trim(response.result) == undefined) {
            content += "<div class='empty-val'><p><strong>No results found.</strong></p></div>";
        }
        else {
            jQuery.each(response.result, function (key, value) {
            //console.log(value);
            var home_team_crest = url_faiconnect + value?.homeTeam.picture;
            var away_team_crest = url_faiconnect + value?.awayTeam.picture;
            var result = value?.homeTeamResult.current + " \u2013 " + value?.awayTeamResult.current;
            var competition = value?.competition.name;
            var match_full_date = new Date(value?.dateTimeUTC).toDateString();
            var match_date = new Date(value?.dateTimeUTC).toLocaleDateString('en-GB');
            var match_time = new Date(value?.dateTimeUTC).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
            var venue = value?.facility.name;
            content += "<div class='core-content' id='" + value?.id + "'>";
            content += "<div class='match-date'><p>" + match_full_date + "</p></div>";
            content += "<div class='match-detail'>";
            content += "<div class='team'><span>" + value?.homeTeam.name + "</span><img id='team-crest' class='team-crest home' src='" + home_team_crest + "' alt='" + value?.homeTeam.place + "' loading='lazy'/></div>";
            content += "<div class='current-result'><span class='match-result'>" + result + "</span></div>";
            content += "<div class='team'><img id='team-crest' class='team-crest away' src='" + away_team_crest + "' alt='" + value?.awayTeam.place + "' loading='lazy'/><span>" + value?.awayTeam.name + "</span></div>";
            content += "</div>";
            content += "<div class='match-date'><p>" + competition + "</p></div>";
            content += "</div>";
            content += "<div class='contents'>";
            content += "<div class='container-match-event'></div>";
            content += "<div class='container-match-info'></div>";
            content += "<div class='match-extra-info'>";
            content += "<div class='competition'><p>" + competition + "</p></div>";
            content += "<div class='round'><p>Round: " + value?.round + "</p></div>";
            content += "<div class='match-date'><p>" + match_date + ", " + match_time + "</p></div>";
            content += "<div class='venue'><p>" + venue + "</p></div>";
            content += "</div>";
            content += "</div>";
            });
        }
        content += "</div>";
        //insert content.
        jQuery('.container-toggle.league.results #toggle-block').append(content);
        },
        error: function (errorThrown) {
            console.log(errorThrown);
        },
    });
//FAI fixture section.
    //api_fixtures
    jQuery.ajax({
        url: api_womens_senior_fai_fixture,
        type: "get",
        headers: {
          "API_KEY": api_key,
        },
        dataType: "json",
        success: function (response) {
          var content = "";
          content += "<div id='wrapper-toggle' class='wrapper-toggle'>";
          if (!jQuery.trim(response.result) || jQuery.trim(response.result) == null || jQuery.trim(response.result) == undefined) {
            content += "<div class='empty-val'><p><strong>No results found.</strong></p></div>";
          }
          else {
            jQuery.each(response.result, function (key, value) {
              var home_team_crest = url_faiconnect + value?.homeTeam.picture;
              var away_team_crest = url_faiconnect + value?.awayTeam.picture;
              var competition = value?.competition.name;
              var match_full_date = new Date(value?.dateTimeUTC).toDateString();
              var time_24h = new Date(value?.dateTimeUTC).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
              var venue = value?.facility.name;
              content += "<div class='core-content'>";
              content += "<div class='match-date'><p>" + match_full_date + "</p></div>";
              content += "<div class='match-detail'>";
                content += "<div class='team'><span>" + value?.homeTeam.name + "</span><img id='team-crest' class='team-crest home' src='" + home_team_crest + "' alt='" + value?.homeTeam.place + "' loading='lazy'/></div>";
                content += "<div class='current-result'><span class='match-time'>" + time_24h + "</span></div>";
                content += "<div class='team'><img id='team-crest' class='team-crest away' src='" + away_team_crest + "' alt='" + value?.awayTeam.place + "' loading='lazy'/><span>" + value?.awayTeam.name + "</span></div>";
                content += "</div>";
                content += "<div class='match-date'><p>" + competition + "</p></div>";
              content += "</div>";
              content += "<div class='contents'>";
              content += "<div class='match-extra-info'>";
              content += "<div class='competition'><p>" + competition + "</p></div>";
              content += "<div class='venue'><p>" + venue + "</p></div>";
              //content += "<div class='ticket-btn'><a href='#'>Buy Ticket</a></div>";
              content += "</div>";
              content += "</div>";
            });
          }
          content += "</div>";
          //insert content.
          jQuery('.container-toggle.fai.fixture #toggle-block').append(content);
        },
        error: function (errorThrown) {
          console.log(errorThrown);
        },
    });  
//FAI results section.
    jQuery.ajax({
      url: api_womens_senior_fai_results,
      type: "get",
      headers: {
        "API_KEY": api_key,
      },
      dataType: "json",
      success: function (response) {
        //console.log(response);
        var content = "";
        content += "<div id='wrapper-toggle' class='wrapper-toggle'>";
        if (!jQuery.trim(response.result) || jQuery.trim(response.result) == null || jQuery.trim(response.result) == undefined) {
          content += "<div class='empty-val'><p><strong>No results found.</strong></p></div>";
        }
        else {
          jQuery.each(response.result, function (key, value) {
            //console.log(value);
            var home_team_crest = url_faiconnect + value?.homeTeam.picture;
            var away_team_crest = url_faiconnect + value?.awayTeam.picture;
            var result = value?.homeTeamResult.current + " \u2013 " + value?.awayTeamResult.current;
            var competition = value?.competition.name;
            var match_full_date = new Date(value?.dateTimeUTC).toDateString();
            var match_date = new Date(value?.dateTimeUTC).toLocaleDateString('en-GB');
            var match_time = new Date(value?.dateTimeUTC).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
            var venue = value?.facility.name;
            content += "<div class='core-content' id='" + value?.id + "'>";
            content += "<div class='match-date'><p>" + match_full_date + "</p></div>";
            content += "<div class='match-detail'>";
              content += "<div class='team'><span>" + value?.homeTeam.name + "</span><img id='team-crest' class='team-crest home' src='" + home_team_crest + "' alt='" + value?.homeTeam.place + "' loading='lazy'/></div>";
              content += "<div class='current-result'><span class='match-result'>" + result + "</span></div>";
              content += "<div class='team'><img id='team-crest' class='team-crest away' src='" + away_team_crest + "' alt='" + value?.awayTeam.place + "' loading='lazy'/><span>" + value?.awayTeam.name + "</span></div>";
              content += "</div>";
              content += "<div class='match-date'><p>" + competition + "</p></div>";
            content += "</div>";
            content += "<div class='contents'>";
            content += "<div class='container-match-event'></div>";
            content += "<div class='container-match-info'></div>";
            content += "<div class='match-extra-info'>";
            content += "<div class='competition'><p>" + competition + "</p></div>";
            content += "<div class='round'><p>Round: " + value?.round + "</p></div>";
            content += "<div class='match-date'><p>" + match_date + ", " + match_time + "</p></div>";
            content += "<div class='venue'><p>" + venue + "</p></div>";
            content += "</div>";
            content += "</div>";
          });
        }
        content += "</div>";
        //insert content.
        jQuery('.container-toggle.fai.results #toggle-block').append(content);
      },
      error: function (errorThrown) {
        console.log(errorThrown);
      },
    });
//tabbed function.
    jQuery("#tab-list li.tab-switcher:not(:first)").addClass("inactive");
    var previousActiveTabIndex = 0;

    jQuery(".tab-switcher").on('click keypress', function (event) {
      // event.which === 13 means the "Enter" key is pressed
      if ((event.type === "keypress" && event.which === 13) || event.type === "click") {
        var tabClicked = jQuery(this).data("tab-index");
        if (tabClicked != previousActiveTabIndex) {
          jQuery("#tab-container .container-toggle").each(function () {
            if (jQuery(this).data("tab-index") == tabClicked) {
              jQuery(".container-toggle").hide();
              jQuery(this).show();
              previousActiveTabIndex = jQuery(this).data("tab-index");
              return;
            }
          });
          if (jQuery("#tab-list li.tab-switcher").hasClass("inactive")) {
            jQuery("#tab-list li.tab-switcher").addClass("inactive");
            jQuery(this).removeClass("inactive");
          }
        }
      }
    });
//accordion/toggle/collapsible function.
    jQuery(document).on("click", ".container-toggle.results #toggle-block .core-content", function () {
      //console.log("clicked!!!");
      jQuery(this).toggleClass("active").next().slideToggle();
      jQuery(".contents").not(jQuery(this).next()).slideUp(300);
      jQuery(this).siblings().removeClass("active");
      let match_id = this.id;
      // match events.
      var api_match_events = base_url + "/api/live/match/" + match_id + "/events?teamIdFilter=" + teamIdFilter;
      var api_match_info = base_url + "/api/live/match/" + match_id + "/info?teamIdFilter=" + teamIdFilter;
      jQuery.ajax({
        url: api_match_events,
        type: "get",
        headers: {
          "API_KEY": api_key,
        },
        dataType: "json",
        success: function (response) {
          var match_content = "";
          //console.log(response);
          match_content += "<div class='wrapper-match-event'>";
          match_content += "<div class='event home-team'>";
          match_content += "<div class='cls-group-match'>";
          jQuery.each(response, function (key, value) {
            //console.log(value);
            if (value?.homeTeam === true) {
              match_content += "<div class='match-event' id='" + value?.eventId + "'>";
              if (value?.eventType.fcdName === "SUBSTITUTION") {
                //var shortName = value?.player.shortName;
                //var shortName2 = value?.player2.shortName;
                var fullName = value?.player.name.split(" ").reverse().join(" ");
                var fullName2 = value?.player2.name.split(" ").reverse().join(" ");
                //match_content += "<div class='substitution'><ul><li><span>" + value?.player.shortName + "</span></li><li><span>"  + value?.player2.shortName + "</span></li></ul></div>";
                match_content += "<div class='substitution'><ul><li><span class='player-name'>" + fullName + "</span></li><li><span class='player-name'>" + fullName2 + "</span></li></ul></div>";
                match_content += "<span>" + value?.displayMinute + "</span>";
                match_content += "<img src='//www.corkcityfc.ie/cdn/shop/t/3/assets/substitution.svg?v=4152711406140138451692278538' loading='lazy'>";
              }
              else {
                //var shortName = value?.player.shortName;
                var fullName = value?.player.name.split(" ").reverse().join(" ");
                //match_content += "<span>" + value?.player.shortName + "</span>";
                match_content += "<span class='player-name'>" + fullName + "</span>";
                match_content += "<span>" + value?.displayMinute + "</span>";
                switch (value?.eventType.fcdName) {
                  case "GOAL":
                    match_content += "<img src='//www.corkcityfc.ie/cdn/shop/t/3/assets/football.svg?v=180361168520299892041692278482' loading='lazy'>";
                    break;
                  case "YELLOW":
                    match_content += "<img src='//www.corkcityfc.ie/cdn/shop/t/3/assets/yellow_card.svg?v=68390974004849421541692278495' loading='lazy'>";
                    break;
                  case "RED":
                    match_content += "<img src='//www.corkcityfc.ie/cdn/shop/t/3/assets/red_card.svg?v=94779937070173988251692278506' loading='lazy'>";
                    break;
                  case "OWN_GOAL":
                    match_content += "<img src='//www.corkcityfc.ie/cdn/shop/t/3/assets/own_goal.svg?v=111979731866681530201692278529' loading='lazy'>";
                    break;
                  case "SECOND_YELLOW":
                    match_content += "<img src='//www.corkcityfc.ie/cdn/shop/t/3/assets/second_yellow.svg?v=91837353746720002361692278519' loading='lazy'>";
                    break;
                }
              }
              match_content += "</div>";
            }
          });
          match_content += "</div></div><div class='empty'></div><div class='event away-team'><div class='cls-group-match'>";
          jQuery.each(response, function (key, value) {
            if (value?.homeTeam === false) {
              match_content += "<div class='match-event' id='" + value?.eventId + "'>";
              if (value?.eventType.fcdName === "SUBSTITUTION") {
                //var shortName = value?.player.shortName;
                //var shortName2 = value?.player2.shortName;
                var fullName = value?.player.name.split(" ").reverse().join(" ");
                var fullName2 = value?.player2.name.split(" ").reverse().join(" ");
                match_content += "<img src='//www.corkcityfc.ie/cdn/shop/t/3/assets/substitution.svg?v=4152711406140138451692278538' loading='lazy'>";
                //match_content += "<div class='substitution'><ul><li><span>" + value?.player.shortName + "</span></li><li><span>"  + value?.player2.shortName + "</span></li></ul></div>";
                match_content += "<div class='substitution'><ul><li><span class='player-name'>" + fullName + "</span></li><li><span class='player-name'>" + fullName2 + "</span></li></ul></div>";
                match_content += "<span>" + value?.displayMinute + "</span>";
              }
              else {
                //var shortName = value?.player.shortName;
                var fullName = value?.player.name.split(" ").reverse().join(" ");
                switch (value?.eventType.fcdName) {
                  case "GOAL":
                    match_content += "<img src='//www.corkcityfc.ie/cdn/shop/t/3/assets/football.svg?v=180361168520299892041692278482' loading='lazy'>";
                    break;
                  case "YELLOW":
                    match_content += "<img src='//www.corkcityfc.ie/cdn/shop/t/3/assets/yellow_card.svg?v=68390974004849421541692278495' loading='lazy'>";
                    break;
                  case "RED":
                    match_content += "<img src='//www.corkcityfc.ie/cdn/shop/t/3/assets/red_card.svg?v=94779937070173988251692278506' loading='lazy'>";
                    break;
                  case "OWN_GOAL":
                    match_content += "<img src='//www.corkcityfc.ie/cdn/shop/t/3/assets/own_goal.svg?v=111979731866681530201692278529' loading='lazy'>";
                    break;
                  case "SECOND_YELLOW":
                    match_content += "<img src='//www.corkcityfc.ie/cdn/shop/t/3/assets/second_yellow.svg?v=91837353746720002361692278519' loading='lazy'>";
                    break;
                }
                //match_content += "<span>" + value?.player.shortName + "</span>";
                match_content += "<span class='player-name'>" + fullName + "</span>";
                match_content += "<span>" + value?.displayMinute + "</span>";
              }
              match_content += "</div>";
            }
          });
          match_content += "</div></div>";
          match_content += "</div>";
          //insert content.
          jQuery('.contents .container-match-event').html(match_content);
        },
        error: function (errorThrown) {
          console.log(errorThrown);
        },
      });
    });
    jQuery(document).on("click", ".container-toggle.fixture #toggle-block .core-content", function () {
      jQuery(this).toggleClass("active").next().slideToggle();
      jQuery(".contents").not(jQuery(this).next()).slideUp(300);
      jQuery(this).siblings().removeClass("active");
    });
});